import {cn} from '@/utils';
import React from 'react';

const CorrectBold = ({className}: {className?: string}) => {
  return (
    <svg
      className={cn('size-3 text-c1', className)}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 5.5L5.38889 8.61111L11 3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CorrectBold;
